/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_CHECKBOX_TICK': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 11',
    data: '<path pid="0" _fill="#4d4dff" d="M5.7 10.67l8.91-8.92L13.2.33 5.7 7.84l-3.9-3.9L.39 5.36l5.31 5.31z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_CHECKBOX_TICK.js